import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice from "./Auth/AuthSlice";
import utilsSlice from "./Utils/UtilsSlice";
import actionSlice from "./Action/ActionSlice";
import transaksiSlice from "./Transaksi/transaksiSlice";
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import storage from "redux-persist/lib/storage";

const reducers = combineReducers({
    auth: authSlice,
    utils : utilsSlice,
    action : actionSlice,
    transaksi : transaksiSlice,
})


const store = configureStore({
    reducer: persistReducer(
      {
        key: 'pos',
        storage
      },
      reducers
    ),
    middleware: getDefaultMiddleware => getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
})

const persistor = persistStore(store);

export {store,persistor}
